/**
 * @generated SignedSource<<4609deef1bedd08d7fbf9bb08ac8a6fc>>
 * @relayHash 1f7921e7a90ca92ed3c05a3fc47d6c57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 844f0177f1e4647773e9a77f397b1a2ed7748af538293d7cd631af927d0aefad

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSetMostRecentlyViewedBoardMutation$variables = {
  id: string;
};
export type useSetMostRecentlyViewedBoardMutation$data = {
  readonly jira: {
    readonly setMostRecentlyViewedBoard: {
      readonly board: {
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSetMostRecentlyViewedBoardMutation = {
  response: useSetMostRecentlyViewedBoardMutation$data;
  variables: useSetMostRecentlyViewedBoardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "id"
  }
],
v3 = {
  "concreteType": "JiraBoard",
  "kind": "LinkedField",
  "name": "board",
  "plural": false,
  "selections": (v2/*: any*/)
},
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSetMostRecentlyViewedBoardMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
            "kind": "LinkedField",
            "name": "setMostRecentlyViewedBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetMostRecentlyViewedBoardMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
            "kind": "LinkedField",
            "name": "setMostRecentlyViewedBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v2/*: any*/),
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "844f0177f1e4647773e9a77f397b1a2ed7748af538293d7cd631af927d0aefad",
    "metadata": {},
    "name": "useSetMostRecentlyViewedBoardMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d4f239c31b9503ceeb4233e40d86d981";

export default node;
